import { ProductServiceModule } from './products.service';
import { CategoryServiceModule } from './categories.service';

export const ProductPickerServiceModule = angular
    .module('app.service.data.productPickerService', [
        ProductServiceModule,
        CategoryServiceModule
    ]).service('productPicker', (
        productService,
        categoryService,
        $q
    ) => {
        return {
            getProductsAndCategories,
            getMinimalProductsAndCategories,
            getMinimalProductVariantsAndCategories
        };

        function getCommonProductsAndCategories(getProductsFn) {
            let promises = [
                getAllProducts(getProductsFn),
                categoryService.getCategoryTree()
                    .then((categories) => {
                        return categoryService.flattenCategories(categories, true);
                    })
            ];
            return $q.all(promises).then((data) => {
                return { products: data[0], categories: data[1] };
            });
        }
        function getProductsAndCategories() {
            return getCommonProductsAndCategories(productService.getProducts);
        }

        function getMinimalProductsAndCategories() {
            return getCommonProductsAndCategories(productService.getMinimalProducts);
        }


        function getMinimalProductVariantsAndCategories() {
            return getCommonProductsAndCategories(productService.getMinimalProductsWithVariants);
        }


        function getAllProducts(getProductsFn, page, results) {
            page = page || 1;
            results = results || [];
            const pageSize = 100;
            return getProductsFn(page, pageSize).then((products) => {
                if (products.length === 0) {
                    return results;
                }
                results.push(...products.items);
                if (page * pageSize < products.totalCount) {
                    return getAllProducts(getProductsFn, page + 1, results);
                }
                return results;
            });
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/productPicker.service.js